import { Droppable } from 'react-beautiful-dnd';
import { NewStepPlaceholderStyle } from './CreateNewStepPlaceholder.styles';
import Box from 'yoda-ui/components/Box';

type CreateNewStepPlaceholderProps = {
  actionOrder: string;
  isDraggingTactic: boolean;
};

const CreateNewStepPlaceholder = ({ actionOrder, isDraggingTactic }: CreateNewStepPlaceholderProps) => {
  const droppableId: string = actionOrder === 'at-start' ? 'create-step-at-start' : `create-step-after-${actionOrder}`;

  return (
    <Droppable droppableId={ droppableId } type="Tactic">
      {
        (placeholderProvided, snapshot) => (
          <Box
            ref={ placeholderProvided.innerRef }
            { ...placeholderProvided.droppableProps }
            sx={ NewStepPlaceholderStyle(snapshot.isDraggingOver, isDraggingTactic) }
          >
            { placeholderProvided.placeholder }
          </Box>
        )
      }
    </Droppable>
  );
};

export default CreateNewStepPlaceholder;
